<ng-container *transloco="let t">
  <div
    id="email-reentry-notice"
    class="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-ld-neutral-50 bg-cover bg-center bg-no-repeat p-4"
    [style.background-image]="backgroundImageUrl()"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="email-reentry-notice-title"
    aria-describedby="email-reentry-notice-message"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="false"
  >
    <div
      id="email-reentry-notice-card"
      class="my-auto flex w-full max-w-[480px] flex-col overflow-hidden bg-white shadow-lg"
    >
      <section id="email-reentry-notice-content" class="flex flex-col p-14 max-sm:px-6 max-sm:py-10">
        <img
          id="email-reentry-notice-logo"
          [ngSrc]="logoUrl()"
          [alt]="partnerDisplayName()"
          width="264"
          height="54"
          priority
          class="h-14 w-auto max-w-full self-start object-contain object-left"
        />

        <h2 id="email-reentry-notice-title" class="mt-6 font-dm text-xl text-ld-primary">
          {{ t('loginEmailReentryNoticeTitle') }}
        </h2>
        <p id="email-reentry-notice-message" class="mt-4 font-dm text-base leading-6 text-ld-neutral-700">
          {{ t('loginEmailReentryNoticeMessage') }}
        </p>

        <button
          #confirmButton
          type="button"
          id="email-reentry-notice-confirm-button"
          class="mt-8 inline-flex h-12 w-48 cursor-pointer items-center justify-center gap-2 self-end bg-ld-link px-6 font-dm text-lg text-white transition-colors hover:bg-ld-link-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ld-link disabled:cursor-wait disabled:opacity-80 max-sm:w-full"
          [attr.aria-label]="t('commonButtonsContinue')"
          [disabled]="isRedirecting()"
          (click)="onConfirm()"
        >
          @if (isRedirecting()) {
            <mat-spinner
              id="email-reentry-notice-spinner"
              diameter="20"
              class="text-white! [&_circle]:stroke-white!"
            ></mat-spinner>
            <span id="email-reentry-notice-loading-label">{{ t('commonLabelsLoading') }}</span>
          } @else {
            <span id="email-reentry-notice-continue-label">{{ t('commonButtonsContinue') }}</span>
            <span id="email-reentry-notice-countdown" aria-hidden="true">({{ countdownSeconds() }})</span>
          }
        </button>
      </section>

      <footer
        id="email-reentry-notice-footer"
        class="flex items-center justify-center bg-ld-neutral-50 px-6 py-5 text-center"
      >
        <p id="email-reentry-notice-footer-text" class="font-dm text-sm text-ld-neutral-700">
          @if (footerConfig(); as footer) {
            {{ t('commonLabelsNmls') }} #{{ footer.nmlsId }} – {{ footer.copyright }}
          } @else {
            {{ t('authRegisterCiamNmlsFooter') }}
          }
        </p>
      </footer>
    </div>
  </div>
</ng-container>
